// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__3peFD","panel__header":"Panel_panel__header__o11Lg","panel__content":"Panel_panel__content__3loQE"};